import Swal from "sweetalert2";

// 422 của FastAPI trả `detail` là MẢNG lỗi Pydantic ({msg: "Value error, ..."}),
// không bóc ra thì popup hiện "[object Object]".
const detailText = (detail) => {
  if (!Array.isArray(detail)) return detail;
  return detail
    .map((d) => String(d?.msg || "").replace(/^Value error, /, ""))
    .filter(Boolean)
    .join("\n") || null;
};

// HRM v3: xưởng không nhận phần sửa này — câu của HRM + chỉ cách xử lý.
const HRM_REFUSED_HINT = "Muốn đổi thì huỷ đơn tạo lại hoặc trao đổi với xưởng.";

export const errorMessage = (err, fallback) => {
  const text = detailText(err?.response?.data?.detail) ||
    err?.response?.data?.message ||
    err?.message ||
    fallback;
  return err?.response?.data?.code === "HRM_EDIT_REFUSED" ? `${text} ${HRM_REFUSED_HINT}` : text;
};

// Người dùng bấm huỷ ở popup xác nhận sửa đơn HRM (services/api-client.js): không
// phải lỗi, không hiện gì.
export const notifyError = (err, fallback = "Đã có lỗi xảy ra") => {
  if (err?.hrmCancelled) return Promise.resolve();
  return Swal.fire({ icon: "error", title: "Lỗi", text: errorMessage(err, fallback) });
};

// Khung nổi KHÔNG dùng SweetAlert: Swal chỉ có một popup, form vừa lưu xong bật
// notifySuccess sẽ đè mất cảnh báo nếu dùng chung.
export const floatingNotice = (text, { variant = "warning", timeout = 8000 } = {}) => {
  const el = document.createElement("div");
  el.className = `alert alert-${variant} shadow`;
  el.setAttribute("role", "status");
  el.style.cssText = "position:fixed;top:84px;right:16px;z-index:2000;max-width:420px;margin:0;";
  el.textContent = text;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), timeout);
};

export const notifySuccess = (text, { title = "Thành công", timer = 1500 } = {}) =>
  Swal.fire({ icon: "success", title, text, timer, showConfirmButton: false });

export const notifyInfo = (text, { title = "Thông báo" } = {}) =>
  Swal.fire({ icon: "info", title, text });

export const notifyWarning = (text, { title = "Cảnh báo" } = {}) =>
  Swal.fire({ icon: "warning", title, text });

export const confirmAction = ({
  title = "Bạn có chắc?",
  text = "",
  html,
  confirmButtonText = "Đồng ý",
  cancelButtonText = "Hủy",
  icon = "warning",
  reverseButtons = false,
} = {}) =>
  Swal.fire({
    title,
    ...(html ? { html } : { text }),
    icon,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    reverseButtons,
  }).then((r) => r.isConfirmed);
